package app.smartcoding.realrate.platform

import androidx.compose.runtime.Composable

@Composable
actual fun GatherConsentAndInitialize(onReady: () -> Unit) {
    onReady()
}
